import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from './axios'

export async function getEquipmentAccessories({ q, page, perPage, equipmentId }) {
    let url = `${BASE_URL}/api/equipment-accessory?`;
    url += getQueryParamsString({ q, page, perPage, equipmentId });

    const res = await axiosInstance.get(url)
    return res.data.Data;
}

export async function createEquipmentAccessories(data) {
    let url = `${BASE_URL}/api/equipment-accessory`;
    const res = await axiosInstance.post(url, data)
    return res.data;
}

export async function updateEquipmentAccessories(id, data) {
    var headers = new Headers();
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    headers.set("Authorization", `Bearer ${getAccessToken()}`);

    let url = `${BASE_URL}/api/equipment-accessory/${id}`;
    const res = await axiosInstance.put(url, data)
    return res.data;
}

export async function deleteEquipmentAccessories(id) {
    let url = `${BASE_URL}/api/equipment-accessory/${id}`;
    const res = await axiosInstance.delete(url)
    return res.data;
}